import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
import { ArbetsorderHandelssortimentBaseCommand } from "./ArbetsorderHandelssortimentBaseCommand";
import { ArbetsorderProduktBaseCommand } from "./ArbetsorderProduktBaseCommand";
import { ArbetsorderProduktinstruktionBaseCommand } from "./ArbetsorderProduktinstruktionBaseCommand";

export class UpdateArbetsorderProduktsattCommand extends BasicCommand<UpdateArbetsorderProduktsattCommand> {
    get primaryKey(): IPrimaryKey<UpdateArbetsorderProduktsattCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }

    arbetsorderId: number;
    produktsatt: boolean;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "ArbetsorderProduktsatt";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateArbetsorderProduktsattCommand";
    constructor(init: (instance: UpdateArbetsorderProduktsattCommand) => void) {
        super(UpdateArbetsorderProduktsattCommand.$type, UpdateArbetsorderProduktsattCommand.$groupKey, CommandType.Replace);
        init(this);
    }

    arbetsorderHandelssortimentComparer = (other: ArbetsorderHandelssortimentBaseCommand | ArbetsorderProduktBaseCommand | ArbetsorderProduktinstruktionBaseCommand) =>
        this.arbetsorderId === other.arbetsorderId;
}
